import SurveyButton from "../UserInput/Buttons/SurveyButton";
import SurveyLogo from "./SurveyLogo";

/**
 * @param {object} props
 * @param {object} props.themeColors
 * @param {React.CSSProperties} props.containerStyle
 */
const SurveyHeader = ({ themeColors, containerStyle }) => {
    return (
        <div style={{ backgroundColor: themeColors.primaryColor, ...containerStyle }} className="z-50">
            <div className="px-[27px] md:px-10 lg:px-20 py-4 flex justify-between w-full items-center">
                <div className="flex-1 hidden md:block">
                    <SurveyLogo src={themeColors.mainLogo} />
                </div>
                {themeColors.contactUs.email && (
                    <div className="flex gap-16 items-center">
                        <span className="md:text-base lg:text-xl font-[500] text-white">
                            Need Help? Speak with an advisor today
                        </span>
                        <SurveyButton
                            colorTheme={themeColors}
                            href={`mailto:${themeColors.contactUs.email}?subject=${encodeURIComponent(`${themeColors.appName} - Appointment request`)}`}
                        >
                            {themeColors.contactUs.buttonText}
                        </SurveyButton>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SurveyHeader;
